/* eslint-disable no-param-reassign */
import React from "react";
import {FormattedMessage, injectIntl, intlShape} from "react-intl";
import Row from "@amzn/meridian/row";
import TaskCountBox from "./TaskCountBox";
import {PROCESS_PATHS} from "../../../utils/Constants";
import useTaskStore from "../../../stores/TaskStore";
import {getExpiredTasks, getPendingTasks, getTranslatedProcessName, isValidTimezone, getEffectivePriority, isElevatedSeverity} from "../../../utils/Helper";
import useContextStore from "../../../stores/ContextStore";
import useFilterStore from "../../../stores/FilterStore";
import Responsive from "@amzn/meridian/responsive";
import {SMALL} from "../../common/constant/BreakPoints";

const moment = require('moment-timezone');

const boxStyle = {
  borderStyle : "solid",
  borderWidth : "1px",
  borderColor : "rgb(187, 192, 193)",
  borderRadius : "4px",
  padding : "1rem"
};

const getProcessCounts = (tasks) => {
  const processCounts = {};
  Object.keys(PROCESS_PATHS).forEach(process => {
    processCounts[process] = tasks.filter(task => (task.category || "").toUpperCase() === process).length;
  });
  return processCounts;
};

function TaskCounts({intl}) {
  const tasks = useTaskStore((state) => state.tasks);
  const taskCounts = useTaskStore((state) => state.taskCounts);
  const stationTimezone = useContextStore((state) => state.stationTimezone);
  const setProcess = useFilterStore((state) => state.setProcess);
  const pendingTasks = getPendingTasks(tasks);
  const expiredTasks = getExpiredTasks(tasks);
  const expiredTodayTasks = expiredTasks.filter(task => {
    const timezone = isValidTimezone(stationTimezone) ? stationTimezone : moment.tz.guess();
    const dueDateTime = moment.unix(task.dueDateTime);
    const midnight = moment.tz(timezone).startOf("day");
    return !dueDateTime.isBefore(midnight);
  });

  const processCounts = getProcessCounts(pendingTasks);
  const highSev = pendingTasks.filter((task) => {
    const effectivePriority = getEffectivePriority(task);
    return isElevatedSeverity(effectivePriority);
  });
  const completedCount = taskCounts.resolvedTaskCount;

  const onClickTaskCountBox = (process) => {
    setProcess([process]);
  };
  
  const PendingTaskBox = () => (
    <div style={boxStyle}>
        <TaskCountBox
          title={<FormattedMessage id="overview.taskCounts.pendingTasks" defaultMessage="Pending Tasks" />}
          count={pendingTasks.length}
        />
    </div>
  )

  const TranslatedProcessBox = () => (
    <div style={boxStyle}>
        <Row wrap="down">
          {Object.keys(processCounts).map(key => <TaskCountBox title={getTranslatedProcessName(key, intl)} count={processCounts[key]} onClick={()=>onClickTaskCountBox(key)} />)}
        </Row>
    </div>
  )
  const HighPririotyTaskBox = () => (
    <div style={boxStyle}>
        <TaskCountBox
          title={<FormattedMessage id="overview.taskCounts.highPriority" defaultMessage="High Priority" />}
          count={highSev.length}
        />
    </div>
  )
  const CompletedTaskBox = () => (
    <div style={boxStyle}>
        <TaskCountBox
          title={<FormattedMessage id="overview.taskCounts.completedToday" defaultMessage="Completed Today" />}
          count={completedCount}
        />
    </div>
  )
  const ExpiredTaskBox = () => (
    <div style={boxStyle}>
        <TaskCountBox
          title={<FormattedMessage id="overview.taskCounts.expiredToday" defaultMessage="Expired Today" />}
          count={expiredTodayTasks.length}
        />
    </div>
  )

  return (
    <Responsive
         query="max-width"
         props = {{
            layout : {
                default : [<PendingTaskBox/>, <TranslatedProcessBox/>, <HighPririotyTaskBox/>, <CompletedTaskBox/>, <ExpiredTaskBox/>],
                [SMALL] : [<PendingTaskBox/>, <HighPririotyTaskBox/>, <TranslatedProcessBox/>, <CompletedTaskBox/>, <ExpiredTaskBox/>]
            },
            widths : {
                defailt : [""],
                [SMALL] : ["fill","fill","grid-12","fill","fill"]
            }
         }}
    >
      {({layout,widths}) => (
        <Row wrap="down" widths={widths} alignmentVertical="stretch">
            {layout}
        </Row>
      )}
    </Responsive>

  );
}

TaskCounts.propTypes = {
  intl : intlShape.isRequired
}

export default injectIntl(TaskCounts);



// WEBPACK FOOTER //
// ./src/components/overview/TaskCounts/TaskCounts.jsx